import React from "react";
import { Instagram, Facebook, Linkedin, Phone } from "lucide-react";
import "../styles/Footer.css";
import logo from "../assets/tact_logo.svg"; // substitua pelo caminho correto da sua logo

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Logo */}
        <div className="footer-logo">
          <img src={logo} alt="Tact Imobi" className="logo-img" />
        </div>

        {/* Siga-nos */}
        <div className="footer-section">
          <h4 className="footer-titulo">Siga-nos</h4>
          <ul className="footer-lista">
            <li><Linkedin size={18} /> Linkedin</li>
            <li><Instagram size={18} /> Instagram</li>
            <li><Facebook size={18} /> Facebook</li>
          </ul>
        </div>

        {/* Política */}
        <div className="footer-section">
          <h4 className="footer-titulo">Política</h4>
          <ul className="footer-lista">
            <li>Privacidade</li>
            <li>Cookies</li>
          </ul>
        </div>

        {/* Fale Conosco */}
        <div className="footer-section">
          <h4 className="footer-titulo">Fale Conosco</h4>
          <ul className="footer-lista">
            <li><Phone size={16} /> (11) 94056-0518</li>
            <li>atendimento@bcbconsultoria.com.br</li>
            <li>Rua Vigário Barreto, 50</li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
